<template>
    <div class="row">
        <div class="col-12 px-0">
            <ul class="qf-dashboard-navigation">
                <li class="qf-active-nav">
                    <a href="#!" @click.prevent>
                        {{$ml.get('reports')}}
                    </a>
                </li>
                <li v-if="loaders.owners || loaders.reports">
                    <a @clisk.prevent>
                        <font-awesome-icon icon="spinner" class="fa-spin"/>
                    </a>
                </li>
                <li></li>
            </ul>
        </div>
        <div class="col-12">
            <div class="row align-items-center">
                <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                    <div class="form-group">
                        <label for="owner">{{$ml.get('Filter_By_Owner')}}
                            <font-awesome-icon icon="spinner" class="fa-spin" v-if="loaders.owners"/>
                        </label>
                        <select name="owner"
                                id="owner"
                                class="form-control"
                                v-model="getParams.owner"
                                @change="changeOwner"
                                :disabled="loaders.reports">
                            <option value="-1">
                                {{$ml.get('all')}}
                            </option>
                            <option v-for="(owner, index) in owners"
                                    :key="`owner${index}`"
                                    :value="owner.id">{{owner.name}}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                    <div class="form-group">
                        <label for="brand">{{$ml.get('Filter_By_Trademark')}}</label>
                        <select name="brand"
                                id="brand"
                                class="form-control"
                                v-model="getParams.brand"
                                @change="changeBrand"
                                :disabled="loaders.reports">
                            <option value="-1">
                                {{$ml.get('all')}}
                            </option>
                            <option v-for="(brand, index) in brands"
                                    :key="`brand${index}`"
                                    :value="brand.id">{{brand.brand_name}}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 pt-3">
            <div class="table-responsive">
                <table class="table qf-table">
                    <thead>
                    <tr>
                        <th>
                            <a href="#!" class="d-inline-flex justify-content-center align-items-center"
                               @click.prevent="changeSort('name')">
                                <div class="qf-sort-order d-flex position-relative">
                                    <font-awesome-icon icon="sort-up" class="qf-sort-up"
                                                       :class="{'qf-active-sort': (getParams.sort.field==='name' && getParams.sort.direction==='desc')}"/>
                                    <font-awesome-icon icon="sort-down" class="qf-sort-down"
                                                       :class="{'qf-active-sort': (getParams.sort.field==='name' && getParams.sort.direction==='asc')}"/>
                                </div>
                                <div>
                                    {{$ml.get('Department')}}
                                </div>
                            </a>
                        </th>
                        <th>
                            <a href="#!" class="d-inline-flex justify-content-center align-items-center"
                               @click.prevent="changeSort('uploadedAt')">
                                <div class="qf-sort-order d-flex position-relative">
                                    <font-awesome-icon icon="sort-up" class="qf-sort-up"
                                                       :class="{'qf-active-sort': (getParams.sort.field==='uploadedAt' && getParams.sort.direction==='desc')}"/>
                                    <font-awesome-icon icon="sort-down" class="qf-sort-down"
                                                       :class="{'qf-active-sort': (getParams.sort.field==='uploadedAt' && getParams.sort.direction==='asc')}"/>
                                </div>
                                <div>
                                    {{$ml.get('Date')}}
                                </div>
                            </a>
                        </th>
                        <th>

                            <a href="#!" class="d-inline-flex justify-content-center align-items-center"
                               @click.prevent="changeSort('trademarks')">
                                <div class="qf-sort-order d-flex position-relative">
                                    <font-awesome-icon icon="sort-up" class="qf-sort-up"
                                                       :class="{'qf-active-sort': (getParams.sort.field==='trademarks' && getParams.sort.direction==='desc')}"/>
                                    <font-awesome-icon icon="sort-down" class="qf-sort-down"
                                                       :class="{'qf-active-sort': (getParams.sort.field==='trademarks' && getParams.sort.direction==='asc')}"/>
                                </div>
                                <div>
                                    {{$ml.get('Registered_Trademarks')}}
                                </div>
                            </a>
                        </th>
                        <th>
                            <a href="#!" class="d-inline-flex justify-content-center align-items-center"
                               @click.prevent="changeSort('matches')">
                                <div class="qf-sort-order d-flex position-relative">
                                    <font-awesome-icon icon="sort-up" class="qf-sort-up"
                                                       :class="{'qf-active-sort': (getParams.sort.field==='matches' && getParams.sort.direction==='desc')}"/>
                                    <font-awesome-icon icon="sort-down" class="qf-sort-down"
                                                       :class="{'qf-active-sort': (getParams.sort.field==='matches' && getParams.sort.direction==='asc')}"/>
                                </div>
                                <div>
                                    {{$ml.get('Matches')}}
                                </div>
                            </a>
                        </th>
                        <!-- <th>{{$ml.get('Archive')}}</th> -->
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-if="loaders.reports">
                        <td colspan="5" class="p-5 h2 text-center">
                            <font-awesome-icon icon="spinner" size="2x" class="fa-spin"/>
                        </td>
                    </tr>
                    <tr v-else
                        v-for="(report, index) in reports"
                        :key="`report${index}`"
                        :class="(parseInt(report.matches) === 0) ? 'qf-opacity-50' : 'qf-clickable'"
                        @click="parseInt(report.matches) !== 0 && goToDetails(report.id, getParams.owner, getParams.brand)"
                    >
                        <td class="py-3">{{report.name}}</td>
                        <td class="py-3">{{report.uploadedAt | dateFormat}}</td>
                        <td class="py-3">{{report.trademarks}}</td>
                        <td class="py-3"><strong>{{report.matches}}</strong></td>
                        <!-- <td class="py-3">
                            <archive-icon height="18" width="18" class="qf-va-sub"></archive-icon>
                        </td> -->

                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="col-12 p-3" v-if="count > getParams.limit">
            <paginator :count="count" :limit="getParams.limit" :offset="getParams.offset"
                       @changePage="changePage"></paginator>
        </div>
    </div>
</template>

<script>
    import Paginator from '../../common/Paginator'

    export default {
        name: "Reports",
        components: {
            Paginator
        },
        props: {
            owner: [String, Number],
            brand: [String, Number]
        },
        data() {
            return {
                reports: [],
                owners: [],
                count: 0,
                getParams: {
                    sort: {
                        field: 'uploadedAt',
                        direction: 'desc'
                    },
                    offset: 0,
                    limit: 30,
                    owner: -1,
                    brand: -1,
                },
                loaders: {
                    reports: false,
                    owners: false
                },
            }
        },
        computed: {
            brands() {
                if (parseInt(this.getParams.owner) === -1 || this.owners.length === 0) {
                    return [];
                } else {
                    let owner = this.owners.find(obj => {
                        return obj.id === this.getParams.owner;
                    });
                    if (owner) {
                        return owner.brands;
                    } else {
                        return [];
                    }
                }
            },
            pages() {
                return Math.ceil(this.count / this.getParams.limit)
            }
        },
        mounted() {
            if (this.owner) {
                this.getParams.owner = parseInt(this.owner);
            }
            if (this.brand) {
                this.getParams.brand = parseInt(this.brand);
            }

            this.getReports();
            this.loaders.owners = true;
            this.$store.dispatch('owners').then(response => {
                this.owners = response;
                this.loaders.owners = false;
            });
        },
        methods: {
            getReports() {
                if (!this.loaders.reports) {
                    this.loading = true;
                    let queryParams = `?sort_by=${this.getParams.sort.field}.${this.getParams.sort.direction}&offset=${this.getParams.offset}&limit=${this.getParams.limit}`;
                    if (parseInt(this.getParams.owner) !== -1) {
                        queryParams += `&owner=${this.getParams.owner}`
                    }
                    if (parseInt(this.getParams.brand) !== -1) {
                        queryParams += `&brand=${this.getParams.brand}`
                    }
                    this.loaders.reports = true;

                    this.$store.dispatch('reports', queryParams).then(response => {
                        this.reports = response['imports'];
                        this.count = parseInt(response.count);
                        this.loaders.reports = false;
                    }).catch(() => {
                        this.loaders.reports = false;
                    });
                }
            },
            changeSort(field) {
                if (!this.loaders.reports) {
                    if (this.getParams.sort.field === field) {
                        this.getParams.sort.direction = (this.getParams.sort.direction === 'asc') ? 'desc' : 'asc'
                    } else {
                        this.getParams.sort = {
                            field: field,
                            direction: 'asc'
                        }
                    }
                    this.getReports();
                }
            },
            changeOwner() {
                if (!this.loaders.reports) {
                    this.getParams.brand = -1;
                    this.getReports();
                }
            },
            changeBrand() {
                if (!this.loaders.reports) {
                    this.getReports();
                }
            },
            goToDetails(matchId, ownerId, brandId) {
                let params = {
                    id: matchId,
                    ownerId: ownerId,
                    brandId: brandId
                };

                this.$router.push({name: 'ReportDetails', params: params});
            },
            changePage(page) {
                if (!this.loaders.reports) {
                    this.getParams.offset = (page - 1) * this.getParams.limit;
                    this.getReports();
                }
            }
        }
    }
</script>

<style scoped>

.qf-opacity-50 {
    opacity: 0.5;
}

.qf-table > thead > tr > th:nth-child(3) > a {
    min-width: 170px;
}

</style>
